import { render } from "./PendingInpectionList.vue?vue&type=template&id=5175ce43&scoped=true"
import script from "./PendingInpectionList.vue?vue&type=script&lang=js"
export * from "./PendingInpectionList.vue?vue&type=script&lang=js"

import "./PendingInpectionList.vue?vue&type=style&index=0&id=5175ce43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5175ce43"]])

export default __exports__